import React, { useCallback, useState } from "react";

import { v4 as uuidv4 } from "uuid";

import { useExtendedAnalytics } from "@app/util/analytic/AnalyticsService";
import AnalyticsContext from "@app/util/contexts/AnalyticsContext";

import EmailComposeModal from "./EmailComposeModal";
import EmailComposeModalsContext, {
  EmailsCreationModalsContextValue,
} from "./EmailComposeModalsContext";
import EmailProvider from "./EmailProvider";

interface EmailComposeModalsProviderProps {
  children: React.ReactNode;
}

const EmailComposeModalsProvider = ({ children }: EmailComposeModalsProviderProps) => {
  const emailCreationAnalytics = useExtendedAnalytics(["Bulk Email Modal"]);

  const [emailModals, setEmailModals] = useState<EmailsCreationModalsContextValue["emailModals"]>(
    []
  );

  const handleEmailModalShow: EmailsCreationModalsContextValue["onEmailModalShow"] = useCallback(
    (params) => {
      const id = uuidv4();
      setEmailModals((emails) => [
        ...emails,
        {
          id,
          params,
        },
      ]);
      return id;
    },
    []
  );

  const handleEmailModalHide: EmailsCreationModalsContextValue["onEmailModalHide"] = useCallback(
    (id) => {
      setEmailModals((emails) => emails.filter((email) => email.id !== id));
    },
    []
  );

  return (
    <EmailComposeModalsContext.Provider
      value={{
        emailModals,
        onEmailModalHide: handleEmailModalHide,
        onEmailModalShow: handleEmailModalShow,
      }}
    >
      {children}
      {emailModals.map(({ id, params }) => (
        <EmailProvider initialValues={params} key={id}>
          <AnalyticsContext.Provider value={emailCreationAnalytics}>
            <EmailComposeModal data-modal-id={id} onHide={() => handleEmailModalHide(id)} />
          </AnalyticsContext.Provider>
        </EmailProvider>
      ))}
    </EmailComposeModalsContext.Provider>
  );
};

export default EmailComposeModalsProvider;
